import React, {Fragment,Component,useState,useEffect} from 'react';
import {connect} from 'react-redux';
import Iframe from "react-iframe"
import { Redirect,Link } from 'react-router-dom';
import { Table,Placeholder } from 'semantic-ui-react';

import {
  Menu,
  Message,
  Segment,
  Container,
  Divider,
  Icon,
  Header,
  Dimmer,
  Responsive,
  Modal,
  Button,
  Image,
  Loader,
  Tab,
  Label
} from 'semantic-ui-react';
import {Base64} from 'js-base64';
import Clipboard from 'react-clipboard.js';

function Guide(props){

  const {t}       = props;
  const mobile    = /Android|iPhone|iPod/.test(navigator.userAgent);
  const title     = props.data.title;
  const port      = props.data.port;
  const password  = props.data.password;
  const code      = props.data.code;
  const hashed    = props.data.hashed;
  const user_id   = props.data.user_id;
  const user_vip  = props.data.user_vip;

  //subscribe_endpoint = "update.glados-config.net";
  //subscribe_endpoint = "update.glados-config.org";
  var subscribe_endpoint = "update.glados-config.com";
  var alt_subscribe_endpoint = "www.glados-config.com";

  const sub    = 'sub://' + Base64.encode(`https://${subscribe_endpoint}/subscribe/${user_id}/${code}/${port}/servers`) + "#Github.com/GLaDOS-network";
  const suburl           = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.yaml`
  const altsub           = `https://${alt_subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.yaml`

  const tv_suburl        = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-tv.yaml`
  const stashurl         = `https://${subscribe_endpoint}/stash/${user_id}/${code}/${port}/glados.yaml`

  const ipv6             = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-ipv6.yaml`
  const padavan_suburl   = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-padavan.yaml`
  const android_suburl   = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.yaml`
  const koolshare_suburl = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/koolshare.yaml`
  const openclash_suburl = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-openclash.yaml`
  const clash_restrict_suburl = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.restrict.yaml`

  var panes = [{
      menuItem:<Menu.Item key='pro222'>
        <svg id="apple" style={{"color":"#333","width":"26px","marginRight":"8px","marginTop":"-4px", "verticalAlign": "middle"}}   viewBox="0 0 36 24">
          <path fillRule="evenodd" clipRule="evenodd" d="M18.7954 2.08851C20.3723 0.0101142 22.5646 0 22.5646 0C22.5646 0 22.8906 1.95403 21.3241 3.8364C19.6514 5.8464 17.7501 5.51751 17.7501 5.51751C17.7501 5.51751 17.3931 3.93677 18.7954 2.08851V2.08851ZM17.9507 6.88629C18.7619 6.88629 20.2675 5.77114 22.2273 5.77114C25.6007 5.77114 26.9279 8.17157 26.9279 8.17157C26.9279 8.17157 24.3323 9.4986 24.3323 12.7186C24.3323 16.3511 27.5657 17.6031 27.5657 17.6031C27.5657 17.6031 25.3054 23.9648 22.2524 23.9648C20.8502 23.9648 19.7601 23.0199 18.2826 23.0199C16.7771 23.0199 15.283 24 14.3098 24C11.522 24.0001 8 17.9653 8 13.1144C8 8.34171 10.9811 5.838 13.7773 5.838C15.5951 5.838 17.0057 6.88629 17.9507 6.88629V6.88629Z" fill="currentColor"/>
        </svg>
        iOS
      </Menu.Item>,
      desktop:true,
      mobile:true,
      render: () => {
        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>
          <h4>{t("settings.clash.tab.ios.advice")}</h4>
          <p>1. {t("settings.clash.tab.ios.get")}</p>

          <ul>
            <li><a href="https://appleid.glados.top">{t("settings.clash.tab.ios.get.1")}</a></li>
            <li><a  href="https://stash.wiki/#stash-for-ios">{t("settings.clash.tab.ios.get.2")}</a></li>
          </ul>

          <p>2. {t("settings.clash.tab.ios.setup")}<br/>
            <Clipboard
              style={{"borderRadius": "5px", "padding": "4px"}}
              onSuccess={()=>{ setClipboard(true) }}
              data-clipboard-text={stashurl}>
              { clipboard ? "copied" : "copy to clipboard" }
            </Clipboard>
            <Label>{stashurl}</Label></p>
          <p>3. {t("settings.clash.tab.ios.hit")}<br/></p>
          <p>4. {t("settings.clash.tab.ios.start")}<br/></p>
        </Tab.Pane>)
      }
    },{
      menuItem:<Menu.Item key='pro222'>
        <svg id="apple" style={{"color":"#333","width":"26px","marginRight":"8px","marginTop":"-4px", "verticalAlign": "middle"}}   viewBox="0 0 36 24">
          <path fillRule="evenodd" clipRule="evenodd" d="M18.7954 2.08851C20.3723 0.0101142 22.5646 0 22.5646 0C22.5646 0 22.8906 1.95403 21.3241 3.8364C19.6514 5.8464 17.7501 5.51751 17.7501 5.51751C17.7501 5.51751 17.3931 3.93677 18.7954 2.08851V2.08851ZM17.9507 6.88629C18.7619 6.88629 20.2675 5.77114 22.2273 5.77114C25.6007 5.77114 26.9279 8.17157 26.9279 8.17157C26.9279 8.17157 24.3323 9.4986 24.3323 12.7186C24.3323 16.3511 27.5657 17.6031 27.5657 17.6031C27.5657 17.6031 25.3054 23.9648 22.2524 23.9648C20.8502 23.9648 19.7601 23.0199 18.2826 23.0199C16.7771 23.0199 15.283 24 14.3098 24C11.522 24.0001 8 17.9653 8 13.1144C8 8.34171 10.9811 5.838 13.7773 5.838C15.5951 5.838 17.0057 6.88629 17.9507 6.88629V6.88629Z" fill="currentColor"/>
        </svg>
        tvOS
      </Menu.Item>,
      desktop:true,
      mobile:true,
      render: () => {
        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>
                        <p>1. 在 Apple TV 上登录美区ID </p>
                        <p>2. 升级 Apple TV 到 tvOS 17</p>
                        <p>3. 在 App Store 搜索 Stash 后购买</p>
                        <p>4. 打开 Stash 添加远程配置文件 {tv_suburl}</p>
                        <p>5. 点击启动，并允许配置 VPN </p>
        </Tab.Pane>)
      }
    }
  ]

  const [clipboard,setClipboard] = useState(false);

  useEffect(()=>{
    if(clipboard == true){
      setTimeout(()=>{
        setClipboard(false)
      },3000)
    }
  },[clipboard])

  return (
  <Fragment>

    <Header as='h2' color="blue">
      {t("settings.stash.title")}
      <Header.Subheader>
      {t("settings.stash.notes")}
      </Header.Subheader>
    </Header>

    <p>{t("settings.clash.steps")}</p>
    <p>1.{t("settings.clash.step1")}</p>
    <p>2.{t("settings.clash.step2")}</p>
    <p>3.{t("settings.clash.step3")}</p>

    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan='3'>
            {t("settings.stash.tab.title")}
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        <Segment>
          <Tab  menu={{ color:"blue", secondary: true}} panes={panes} />
        </Segment>
      </Table.Body>
    </Table>

  </Fragment>
  )
}
export {Guide};
